import React, { useState, useEffect } from "react";
import CompassImg from "../assets/compass.png";

const StyledInputRange = ({ state, setState }) => {
  const [value, setValue] = useState(state || 0);

  const points = [1, 2, 3]; // Define slider points

  useEffect(() => {
    // Ensure filters object exists before setting value
    if (state.filters) {
      setValue(state.filters.activityScale || 0);
    }
  }, [state]);

  const handleChange = (e) => {
    const newValue = parseInt(e, 10);
    setValue(newValue);

    // Preserve the other filter values when updating the state
    setState((prevState) => ({
      ...prevState,
      filters: {
        ...prevState.filters,
        activityScale: newValue,
      },
    }));
  };

  console.log("data in values", value)

  return (
    // <div className="w-full flex flex-col items-center space-y-6">
    //   <div className="relative w-full px-4 bg-aths -ml-8">
    //     <div
    //       className="absolute flex justify-center items-center w-4 h-4 object-contain bg-orange rounded-full z-20"
    //       style={{
    //         left: `${(value / (points.length - 1)) * 100 + (value < 3 ? 3 : 5)
    //           }%`,
    //         transform: "translateX(-50%) translateY(-55%)",
    //       }}
    //     >
    //       <img src={CompassImg} alt="Current Point" className="w-4 h-4" />
    //     </div>

    //     <div className="absolute top-1/2 transform -translate-y-1/2 w-full h-1 bg-aths rounded-full">
    //       <div
    //         className="absolute h-1 bg-orange rounded-full"
    //         style={{
    //           width: `${(value / (points.length - 1)) * 100}%`,
    //         }}
    //       ></div>
    //     </div>

    //     <div className="relative flex justify-between items-center w-full px-2">
    //       {points.map((point, index) => (
    //         <div
    //           key={index}
    //           className="flex flex-col items-center"
    //           style={{
    //             position: "absolute",
    //             left: `${(index / (points.length - 1)) * 100 + (index == 2 ? 7 : index == 1 ? 3 : 0)}%`,
    //             transform: "translateX(-50%) translateY(0%)",
    //           }}
    //         >
    //           <span
    //             className={`w-3 h-3 flex items-center justify-center rounded-full ${value >= point
    //               ? "bg-orange text-white"
    //               : "bg-[#0000005E] text-gray-700"
    //               }`}
    //           ></span>
    //         </div>
    //       ))}
    //     </div>

    //     <input
    //       type="range"
    //       min="0"
    //       max={points.length - 1}
    //       step="1"
    //       value={value}
    //       onChange={handleChange}
    //       className="absolute top-0 w-full h-2 opacity-0 cursor-pointer px-3"
    //     />
    //   </div>
    // </div>
    <div className="w-full flex flex-col items-center space-y-6">
      <div className="relative w-full ">
        {/* Progress Line */}
        <div className="absolute top-1/2 left-0 right-0 h-2 bg-white rounded-full transform -translate-y-1/2">
          <div
            className="absolute h-2 bg-orange rounded-full transition-all duration-300"
            style={{
              width: `${(value / (points.length - 1)) * 100}%`,
            }}
          ></div>
        </div>

        {/* Points */}
        <div className="relative flex justify-between items-center w-full">
          {points.map((point, index) => (
            <div className="border-2 border-white rounded-lg bg-bgprimary p-2" key={index}>
              <div

                className={`w-5 h-5 flex items-center justify-center rounded-md border-2 ${index <= value
                  ? "bg-orange border-orange"
                  : "bg-bgprimary border-bgprimary"
                  } cursor-pointer transition-all duration-300`}
                onClick={() => handleChange(index)}
              ></div>
            </div>

          ))}
        </div>
      </div>
    </div>
  );
};

export default StyledInputRange;
